<template>
    <div>
        <div class="afu-w-full afu-p-3 sm:afu-p-6 afu-bg-white afu-shadow-lg afu-rounded-md afu-m-auto sm:afu-max-w-xl afu-w-100">
            <div class="afu-text-center">
                <h4 class="afu-mb-2">
                    {{ $t('reset_email.title') }}
                </h4>

                <C1Spinner v-if="spinner.reset_email" />

                <template v-else>
                    <p
                        v-if="isEmailReset"
                        class="afu-mb-0 afu-text-success-400"
                    >
                        {{ $t('reset_email.success') }}
                    </p>

                    <p
                        v-else
                        class="afu-mb-0 afu-text-danger-400"
                        v-html="errorMessage"
                    />
                </template>
            </div>
        </div>

        <div class="afu-text-center afu-mt-5 md:afu-mt-10">
            <a
                href="/user-login"
                class="text-sm afu-text-primary-400 hover:afu-text-primary-400 afu-underline hover:afu-no-underline"
            >
                {{ $t('register.back') }}
            </a>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import C1Spinner from '@/components/C1Components/C1Spinner';

    export default {
        name: 'ResetEmail',
        components: { C1Spinner },
        data() {
            return {
                token: '',
                isEmailReset: false,
                errorMessage: '',
                spinner: {
                    reset_email: true,
                },
            };
        },

        computed: {
            ...mapState({
                $_apiMessage: state => state.apiMessage,
            }),
        },

        async created() {
            const urlParams = new URLSearchParams(window.location.search);
            this.token = urlParams.get('token');

            if (!this.token) {
                window.location.href = '/user-login';
            }

            this.resetEmail();
        },

        methods: {
            ...mapActions('auth', {
                $_resetEmail: 'resetEmail',
            }),

            resetEmail() {
                this.spinner.reset_email = true;

                this.$_resetEmail(this.token).then(() => {
                    this.isEmailReset = true;
                }).catch((error) => {
                    const errorCode = error?.response?.data?.error || 'ServerErrorException';
                    this.errorMessage = this.$_apiMessage[errorCode];
                }).finally(() => {
                    this.spinner.reset_email = false;
                });
            },
        },
    };
</script>
